<!--(clickOutside)="onCancelClicked($event)"  -->
<div class="DateRangePicker">
  <app-icon-asset class="DateRangePicker__Icon"
                           [name]="'calender_icon'"
                           [alt]="'calendar icon'"  >
  </app-icon-asset>
  <app-select class="DateRangePicker__Select"
                       [isDateRange]="true" (click)="openDatePickerModel();"
                       [options]="toggleValue">
  </app-select>
  <div class="DateRangePicker__Duration"
       [ngClass]="{'WithDatePicker': isDatePickerVisible}"
       *ngIf="isDurationVisible">
    <form>
      <div class="form-group with-margin-bottom">
        <label>
          {{ 'common.duration' | translate }}
        </label>
        <app-select id="duration"
                             class="DateRangePicker__OptionsSelect"
                             [textCentered]="false"
                             [selectedItem]="durationSelectedOption"
                             [ngClass]="{'Large': isDatePickerVisible}"
                             (changeSelect)="onDurationChange($event)"
                             [largeSize]="true"
                             [options]="durationOptions">
        </app-select>
      </div>
      <div style="display: grid;grid-template-columns: 1fr 1fr;" class="form-group flex-form-group"
           *ngIf="isDatePickerVisible">
        <div class="form-group" >
          <label for="from">
            {{ 'common.from' | translate }}
          </label>
          <input type="text"
                 class="form-control"
                 readonly
                 [(ngModel)]="dateFrom"
                 name="dateFrom"
                 (click)="dp.toggle()"
                 id="from">
        </div>
        <div class="form-group">
          <label for="to">
            {{ 'common.to' | translate }}
          </label>
          <input type="text"
                 class="form-control"
                 readonly
                 (click)="dp.toggle()"
                 [(ngModel)]="dateTo"
                 name="dateTo"
                 id="to">
        </div>
      </div>
      <div class="form-group"
           id="datePickerWrapper"  >
        <input class="form-control"
               [maxDate]="maxDate"
               [bsValue]="bsInlineRangeValue"
               [isOpen]="isDatePickerVisible"
               (bsValueChange)="onDatePickerChange($event)"
               [outsideClick]="false"
               [placeholder]="'store.datePicker.selectDate' | translate"
               #dp="bsDaterangepicker"
               class="form-control"
               bsDaterangepicker>
      </div>
      <div class="DateRangePicker__Controls">
        <button class="btn Controls__BtnCancel"
                type="button"
                (click)="onCancelClicked()">
          {{ 'common.cancel' | translate }}
        </button>
        <button class="btn Controls__BtnApply"
                type="button"
                (click)="onApplyClicked()">
          {{ 'common.apply' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
